/** Letters (including accented/international) and combining marks. */
const INVALID_NAME_CHAR = /[^\p{L}\p{M}\s]/u;
const NAME_PATTERN = /^[\p{L}\p{M}\s]+$/u;

/** Strip numbers and special characters; keep letters, combining marks, and spaces. */
export function sanitizeNameInput(value: string): string {
  return value.replace(/[^\p{L}\p{M}\s]/gu, "");
}

export function isDisallowedNameKey(key: string): boolean {
  if (key.length !== 1) return false;
  return INVALID_NAME_CHAR.test(key);
}

export function validateNameField(fieldLabel: string, value: string): string | undefined {
  if (!value) return `${fieldLabel} is required`;
  if (value.trim().length === 0) return `${fieldLabel} cannot be only spaces`;
  if (!NAME_PATTERN.test(value)) {
    return `${fieldLabel} can only contain letters`;
  }
  if (value.trim().length < 3) return `${fieldLabel} must be at least 3 characters`;
  if (value.trim().length > 35) return `${fieldLabel} must not exceed 35 characters`;
  return undefined;
}
